import React from 'react';
import $ from 'jquery';
import './style.scss';

const ModalSuccess = () => {
  const handleLogin = (e) => {
    $('#modal-success')
      .removeClass('show')
      .css('display', 'none')
      .attr('aria-hidden', true);
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
  };
  return (
    <div className='modal fade modal-success' id='modal-success'>
      <div className='modal-dialog modal-dialog-centered' role='document'>
        <div className='modal-content'>
          <div className='modal-success-content'>
            <h5 className='text-danger text-center'>
              Đăng ký tài khoản thành công!
            </h5>
            <span className='text-center'>
              Hãy cùng bắt đầu quá trình chuyển đổi số.
            </span>
            <div className='modal-success-action'>
              <button
                type='submit'
                className='btn_submit flex-center'
                onClick={handleLogin}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalSuccess;
